import { useJerseyIdentifiers } from '@/hooks/useJerseyIdentifiers';
import JerseySkuReview from './JerseySkuReview';
import type { ValidatedProductGroup } from '@/utils/bulkImportValidation';
import type { JerseySkuReview as Review } from '@klothiq/domain';
import { assertJerseyReview } from '@klothiq/domain';
import { useState } from 'react';

function GroupReview({
  profileId,
  group,
  onChange,
}: {
  profileId: string;
  group: ValidatedProductGroup;
  onChange: (v: Review) => void;
}) {
  const context = useJerseyIdentifiers(profileId, group.existing_id);
  const [error, setError] = useState('');
  return (
    <section className="space-y-2 rounded-xl border border-border p-3">
      <h3 className="text-sm font-semibold">
        {group.name} · rows {group.sourceRows.join(', ')}
      </h3>
      {context.isLoading && <p className="text-xs text-muted-foreground">Loading SKU mappings…</p>}
      {context.error && (
        <p role="alert" className="text-sm text-destructive">
          {context.error.message}{' '}
          <button
            type="button"
            className="min-h-11 underline"
            onClick={() => void context.refetch()}
          >
            Retry
          </button>
        </p>
      )}
      {context.data && (
        <JerseySkuReview
          context={context.data}
          value={group.jersey_review || context.data.review}
          error={error}
          onChange={(review) => {
            setError('');
            try {
              if (review.confirmed) assertJerseyReview(context.data, review);
              onChange(review);
            } catch (e) {
              setError((e as Error).message);
              onChange({ ...review, confirmed: false });
            }
          }}
        />
      )}
    </section>
  );
}
export default function JerseyImportReviews({
  profileId,
  groups,
  onChange,
}: {
  profileId: string;
  groups: ValidatedProductGroup[];
  onChange: (key: string, review: Review) => void;
}) {
  return (
    <div className="space-y-3">
      {groups
        .filter((g) => g.match === 'new' || g.variants.some((v) => v.match === 'new'))
        .map((group) => (
          <GroupReview
            key={group.group_key}
            profileId={profileId}
            group={group}
            onChange={(review) => onChange(group.group_key, review)}
          />
        ))}
    </div>
  );
}
